import { render, staticRenderFns } from "./AccreditationsControl.vue?vue&type=template&id=882cadb8&"
import script from "./AccreditationsControl.vue?vue&type=script&lang=js&"
export * from "./AccreditationsControl.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationsControl.vue?vue&type=style&index=0&id=882cadb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports